import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants';
import dataModel from '../../models/DataModel';
import activityLogServices from '../../services/activityLogServices';

export default class 
ProjectActivityCollection extends AOCollection {
  constructor(project_id, userId, companyId, recordDescriptor) {
    super({
      name: ReduxConstants.PROJECT_ACTIVITY + '_' + project_id,
      collectionType: ReduxConstants.EVENT_HISTORY,
      userId,
      companyId,
      recordDescriptor,
    });
    this.project_id = project_id;
  }

  static build(project_id, userId, companyId, recordDescriptor) {
    const collection = new ProjectActivityCollection(project_id, userId, companyId || localStorage.current_company_id, recordDescriptor);
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      dataModel.collectionsDAO.setCollection(collection.getKey(), collection.getData(), collection.getCollectionType(), recordDescriptor);
    }
    else {
      collection.ids = collectionData.ids;
      collection._filter = collectionData._filter;
      collection.recordDescriptor = collectionData.recordDescriptor;
    }
    return collection;
  }

  handleOffLineFetch(options) {

    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection);
    });
  }

  async fetchCurrent(dummy, options = {}) {
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      let serviceCall = activityLogServices.getProjectActivity.bind(this, this.project_id, options);

      let newCollection = await this._fetchData(serviceCall, options);
      if (newCollection.offline) {
        return this.handleOffLineFetch(options);
      }
      return newCollection;
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/ProjectActivityCollection.js